<script setup>

import Trans from '@/i18n/translation.js';
import { trackEvent } from '@/services/analytics/googleAnalytics.js';

const props = defineProps({
  href: {
    type: String,
    default: '#',
  },
  sectionName: {
    type: String,
    default: 'General',
  },
  text: {
    type: String,
    default: '',
  },
});

const contactNavigation = Trans.i18nRoute({ name: 'contact' });

const handleClick = () => {
  trackEvent('clicked_cta', {
    event_category: props.sectionName,
    event_label: 'cta_button',
  });
};
</script>

<template>
  <RouterLink :to="contactNavigation"
    class="rounded-lg bg-terciary px-6 py-3 text-lg sm:max-w-100px font-semibold text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 transition-all inline-block"
    @click="handleClick">
    {{ text }}
  </RouterLink>
</template>
